export default __webpack_public_path__ + "static/media/Home-section-3.d6572b9c.png";